/*  ==========================================================================
    IMAGES
    ========================================================================== */

/*
 * IMPORTS
 */

// node modules imports
import $ from 'jquery';

// local imports
import * as vars from '../../globals/variables';
import * as utils from '../../utilities/utils';

/*
 * MODULE
 */

export function initImages($element) {

    // magnific popup
    utils.mfp.initGallery($element);

}


// WEBPACK FOOTER //
// ./source/js/modules/lib/images.js